module.exports = __webpack_public_path__ + "img/SensorUnAssign.8882017a.svg";